import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-settings-icon',
  templateUrl: 'settings-icon.component.html'
})
export class SettingsIconComponent {
  constructor() {}
}
